module.exports = __webpack_public_path__ + "press_page_mockup_responsive_design_ipad_iphone_webdesign_mobiledesign_digitalfactory.jpg?77579d4662bf3a43e93680d55bec1f9a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/digital _factory/press_page_mockup_responsive_design_ipad_iphone_webdesign_mobiledesign_digitalfactory.jpg
// module id = 58
// module chunks = 0